export const CHECKBOX_HEIGHT = 22;
export const CHECKBOX_PADDING_Y = 2;
